

import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MwcFormPatchModule } from 'mwc/core/form';
import { MwcNoAnimationModule } from 'mwc/core/no-animation';
import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcOverlayModule } from 'mwc/core/overlay';
import { ɵMwcTransitionPatchModule as MwcTransitionPatchModule } from 'mwc/core/transition-patch';
import { MwcEmptyModule } from 'mwc/empty';
import { MwcI18nModule } from 'mwc/i18n';
import { MwcIconModule } from 'mwc/icon';
import { MwcInputModule } from 'mwc/input';
import { MwcCheckboxModule } from 'mwc/checkbox';

import { MwcOptionContainerComponent } from './option-container.component';
import { MwcOptionGroupComponent } from './option-group.component';
import { MwcOptionItemGroupComponent } from './option-item-group.component';
import { MwcOptionItemComponent } from './option-item.component';
import { MwcOptionComponent } from './option.component';
import { MwcSelectArrowComponent } from './select-arrow.component';
import { MwcSelectClearComponent } from './select-clear.component';
import { MwcSelectItemComponent } from './select-item.component';
import { MwcSelectPlaceholderComponent } from './select-placeholder.component';
import { MwcSelectSearchComponent } from './select-search.component';
import { MwcSelectTopControlComponent } from './select-top-control.component';
import { MwcSelectComponent } from './select.component';

@NgModule({
  imports: [
    BidiModule,
    CommonModule,
    MwcI18nModule,
    FormsModule,
    PlatformModule,
    OverlayModule,
    MwcIconModule,
    MwcOutletModule,
    MwcEmptyModule,
    MwcOverlayModule,
    MwcNoAnimationModule,
    MwcTransitionPatchModule,
    MwcFormPatchModule,
    ScrollingModule,
    MwcInputModule,
    MwcCheckboxModule,
    A11yModule
  ],
  declarations: [
    MwcOptionComponent,
    MwcSelectComponent,
    MwcOptionContainerComponent,
    MwcOptionGroupComponent,
    MwcOptionItemComponent,
    MwcSelectTopControlComponent,
    MwcSelectSearchComponent,
    MwcSelectItemComponent,
    MwcSelectClearComponent,
    MwcSelectArrowComponent,
    MwcSelectPlaceholderComponent,
    MwcOptionItemGroupComponent
  ],
  exports: [
    MwcOptionComponent,
    MwcSelectComponent,
    MwcOptionGroupComponent,
    MwcSelectArrowComponent,
    MwcSelectClearComponent,
    MwcSelectItemComponent,
    MwcSelectPlaceholderComponent,
    MwcSelectSearchComponent
  ]
})
export class MwcSelectModule {}
